import { CurrentUser } from "models/auth/CurrentUser";
import { createContext, useContext, useMemo, useReducer } from "react";
import { CurrentUserService } from "services/currentUser";
import currentUserReducer, { CurrentUserAction } from "./currentUserReducer";

export const CurrentUserContext = createContext<CurrentUser | null | undefined>(
	undefined
);
export const CurrentUserDispatchContext = createContext<React.Dispatch<{
	type: CurrentUserAction;
	user?: CurrentUser | null;
}> | null>(null);

export function CurrentUserProvider({ children }: React.PropsWithChildren) {
	const [user, dispatch] = useReducer(currentUserReducer, undefined);

	const currentUserService: CurrentUserService = useMemo(
		CurrentUserService.getInstance,
		[]
	);

	if (user === undefined) {
		currentUserService
			.getCurrentUser()
			.then((response: CurrentUser) => {
				dispatch({ type: CurrentUserAction.LOGIN, user: response });
			})
			.catch(() => {
				dispatch({ type: CurrentUserAction.LOGIN, user: null });
			});
	}

	return (
		<CurrentUserContext.Provider value={user}>
			<CurrentUserDispatchContext.Provider value={dispatch}>
				{children}
			</CurrentUserDispatchContext.Provider>
		</CurrentUserContext.Provider>
	);
}

export function useCurrentUser() {
	return useContext(CurrentUserContext);
}

export function useCurrentUserDispatch() {
	return useContext(CurrentUserDispatchContext);
}
